<template>
  <div>
    <div class="columns">
      <div class="column">
        <h2 class="title is-3">Список изображений</h2>
      </div>
      <div class="column">
        <b-button
          class="is-pulled-right"
          type="is-primary"
          icon-right="plus"
          @click="createFirebaseImg"
        >Добавить изображение</b-button>
      </div>
    </div>

    <!-- ТАБЛИЦА -->
    <b-table
      :data="firebase_imgs"
      class="users-table"
    >
      <b-table-column label="ID" v-slot="props">
        <span>{{ props.row.id }}</span>
      </b-table-column>

      <b-table-column label="Превью" v-slot="props">
        <div class="image" style="width: 150px;">
          <img
            :src="props.row.url" />
        </div>
      </b-table-column>

      <b-table-column label="Имя" v-slot="props">
        <span>{{ props.row.name }}</span>
      </b-table-column>

      <b-table-column label="Ссылка" v-slot="props">
        <span>{{ props.row.url }}</span>
      </b-table-column>

      <b-table-column label="Действия" v-slot="props">

        <div>
          <b-tooltip label="Копировать">
            <b-button @click="copyUrl(props.row.url)">
              Копировать
            </b-button>
          </b-tooltip>

          <b-tooltip label="Редактировать">
            <b-button class="edit_icon" @click="updateFirebaseImg(props.row.id)">
              <svg viewBox="0 0 24 24" fill="none" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
                <path d="M4 20h4l10.5 -10.5a1.5 1.5 0 0 0 -4 -4l-10.5 10.5v4"></path>
                <path d="M13.5 6.5l4 4"></path>
              </svg>
            </b-button>
          </b-tooltip>

          <b-tooltip label="Удалить">
            <b-button
              class="delete_icon"
              @click="deleteFirebaseImg(props.row)">
              <svg viewBox="0 0 24 24" fill="none" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
                <path d="M4 7l16 0"></path>
                <path d="M10 11l0 6"></path>
                <path d="M14 11l0 6"></path>
                <path d="M5 7l1 12a2 2 0 0 0 2 2h8a2 2 0 0 0 2 -2l1 -12"></path>
                <path d="M9 7v-3a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v3"></path>
              </svg>
            </b-button>
          </b-tooltip>
        </div>

      </b-table-column>
    </b-table>

    <OverlayLoader :show="isLoading"></OverlayLoader>
    <FirebaseImgDetailsModal></FirebaseImgDetailsModal>
    <FirebaseImgConfirmDeleteModal></FirebaseImgConfirmDeleteModal>

  </div>
</template>

<script>
import FirebaseImgDetailsModal from '@/app/client/firebase/shared/modals/firebaseImgDetailsModal.vue';
import FirebaseImgConfirmDeleteModal from '@/app/client/firebase/shared/modals/confirmDeletionFirebaseImgModal.vue';
import OverlayLoader from "@/app/shared/components/app-loader/Loader";

export default {
  name: "FirebaseImgsList",
  components: {
    OverlayLoader,
    FirebaseImgDetailsModal,
    FirebaseImgConfirmDeleteModal
  },
  data() {
    return {
    };
  },
  created() {
    this.getFirebaseImgs();
  },
  computed: {
    firebase_imgs() {
      return this.$store.getters.GET_FIREBASE_IMGS;
    },
    detailOpened: {
      get() {
        return this.$store.getters.GET_FIREBASE_IMG_DETAILS_MODAL_OPENED;
      },
      set(value) {
        this.$store.commit("SET_FIREBASE_IMG_DETAILS_MODAL_OPENED", value);
      },
    },
    isLoading: {
      get() {
        return this.$store.getters.IS_FIREBASE_IMGS_LOADING;
      },
      set(value) {
        this.$store.commit("SET_FIREBASE_IMGS_LOADING", value);
      },
    },
  },
  methods: {
    async copyUrl(url) {
      try {
        await navigator.clipboard.writeText(url)
        this.$toast.success("Ссылка скопирована в буфер обмена");
      } catch (err) {
        this.$toast.error("Не удалось скопировать ссылку");
      }
    },
    getFirebaseImgs() {
      this.$store.dispatch("GET_FIREBASE_IMGS").catch(() => {
        this.$toast.error("Ошибка при получении данных");
      });
    },
    updateFirebaseImg(id) {
      this.$store.dispatch("GET_FIREBASE_IMG_BY_ID", id).then(() => {
        this.detailOpened = true;
      }).catch(() => {
        this.$toast.error("Ошибка при получении данных");
      });
    },
    deleteFirebaseImg(firebase_img) {
      this.$store.commit("SET_CURRENT_FIREBASE_IMG", firebase_img);
      this.$store.commit('SET_CONFIRM_DELETION_FIREBASE_IMG_MODAL', true);
    },
    createFirebaseImg() {
      this.$store.commit("SET_CURRENT_FIREBASE_IMG", {});
      this.detailOpened = true;
    },
  },
};
</script>

<style>
.draggable-item {
  border: 1px solid rgba(0, 0, 0, 0.125);
  padding: 10px;
  background-color: #fff;
}
</style>
